import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import createRootReducer from './reducers'
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
export const history = createBrowserHistory()
const store = createStore(
  createRootReducer(history), // root reducer with router state
  undefined,
  composeEnhancers(
    applyMiddleware(
      routerMiddleware(history) // for dispatching history actions
    )
  )
)
export default store
